import gql from 'graphql-tag';

import {urgencyMessageFragments} from '../UrgencyMessage/UrgencyMessage.fragments';

import {fragments as detailsFragments} from '../Details/Details';
import {fragments as geoDistanceFragments} from '../GeoDistance/GeoDistance';
import {fragments as priceFragments} from '../Price/Price';
import {fragments as ratingFragments} from '../Rating/Rating';

export const hitInfoMobileFragments = {
    Listing: gql`
        fragment HitInfoMobileListing on Listing {
            detailPageUrl
            instantBookable
            minStayRange {
                minStayHigh
                minStayLow
            }
            listingId
            rankedBadges(rankingStrategy: SERP) {
                id
                helpText
                name
            }
            propertyId
            listingNumber
            propertyType
            propertyMetadata {
                headline
                propertyName
            }
            superlativesBadges: rankedBadges(
                rankingStrategy: SERP_SUPERLATIVES
            ) {
                id
                helpText
                name
            }
            unitMetadata {
                unitName
            }
            ...DetailsListing
            ...GeoDistanceListing
            ...PriceListing
            ...RatingListing
            ...UrgencyMessageListing
        }
        ${detailsFragments.Listing}
        ${geoDistanceFragments.Listing}
        ${priceFragments.Listing}
        ${ratingFragments.Listing}
        ${urgencyMessageFragments.Listing}
    `
};
